var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"logout mt-12",attrs:{"outlined":""},on:{"click":_vm.logout}},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('v-icon',{staticClass:"ml-2",attrs:{"color":"#eb6573","size":"21"}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }